export const setSession = (name, value) => {
  sessionStorage.setItem(name, value);
};

export const getSession = (cname = '') => sessionStorage.getItem(cname);

export const removeSession = cname => sessionStorage.removeItem(cname);
